<template>
  <!-- <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.CONFIRM"
    :handler="() => $refs.modal.show()"
  /> -->

  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.INITIATION_FAILED"
    :handler="() => $refs.modal.show()"
  />

  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.INITIATED"
    :handler="() => $refs.modal.show()"
  />

  <DialogComponent
    ref="modal"
    type="modal"
    hideCloseButton
    noInnerPadding
    @closed="
      ({ source }) => {
        source !== 'continueAction' &&
          $stores.services.state?.paymentInitiated &&
          $bus.emit($constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION);
      }
    "
  >
    <div
      class=" w-full flex items-center justify-center text-center p-6 pt-0 -mt-2 "
    >
      <div
        v-if="$stores.services.state?.initiatingPayment"
        class="flex flex-col items-center space-y-4"
      >
        <ImgComponent
          src="https://cdn-icons-png.flaticon.com/512/189/189792.png"
          class="max-w-xl w-[60vw] animate-spin opacity-70 p-[20%]"
        />
        <h2 class="text-2xl font-semibold">Traitement en cours</h2>
        <p class="text-gray-600">Veuillez patienter…</p>
      </div>

      <!-- ERROR -->
      <div
        v-else-if="$stores.services.state?.initiationError"
        class="flex flex-col items-center space-y-4"
      >
        <div class="max-w-xl w-[60vw] saturate-50">
          <LottieComponent
            class="scale-150"
            :src="$constants.SERVICES.LOTTIES.PAYMENT_ERROR"
          />
        </div>
        <h2 class="text-2xl font-semibold text-primary">
          {{ $stores.services.state?.initiationErrorTitle }}
        </h2>
        <p class="text-gray-600">
          {{ $stores.services.state?.initiationError }}
        </p>
        <div class="flex gap-5">
          <button
            class="buttonComponent text-2xl border-primary border bg-transparent! text-primary!"
            @click="() => $refs.modal.hide()"
          >
            Terminer
          </button>
        </div>
      </div>

      <!-- SUCCESS -->
      <div
        v-else-if="$stores.services.state?.paymentInitiated"
        class="flex flex-col items-center space-y-4"
      >
        <div class="max-w-xl w-[60vw]">
          <LottieComponent
            class="scale-150"
            :src="$constants.SERVICES.LOTTIES.PAYMENT_SUCCESS"
          />
        </div>
        <h2 class="text-2xl font-semibold text-green-600">Paiement initié</h2>
        <p class="text-gray-600">
          {{ 'La transaction a été démarrée avec succès.' }}
        </p>
        <div>
          <button
            class="buttonComponent text-2xl"
            @click="() => $refs.modal.hide()"
          >
            Terminer
          </button>
        </div>
      </div>

      <!-- DEFAULT -->
      <div v-else class="flex flex-col items-center space-y-4">
        <ImgComponent
          src="https://cdn-icons-png.flaticon.com/512/1828/1828901.png"
          class="w-20 h-20"
        />
        <h2 class="text-xl font-semibold">Aucune donnée</h2>
        <p class="text-gray-500">En attente d'une nouvelle opération…</p>
        <div>
          <button
            class="buttonComponent text-2xl"
            @click="() => $refs.modal.hide()"
          >
            Terminer
          </button>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>
